{
  "filter": "Filtre",
  "filters": "Filtres",
  "ok": "OK",
  "cancel": "Annuler",
  "close": "Fermer",
  "delete": "Supprimer",
  "update": "Modifier",
  "remove": {
    "user": "Supprimer un utilisateur"
  },
  "search": "Rechercher",
  "back": "Retour",
  "validate": "Valider",
  "save": "Sauvegarder",
  "archive": "Archive",
  "send": "Envoyer",
  "disable": "Inactif",
  "enable": "Actif",
  "create": {
    "_": "Nouveau",
    "rootCa": "Charger la root CA"
  },
  "next": "Suivant",
  "previous": "Précédent",
  "test": {
    "pki": "Tester la connexion"
  },
  "slider": {
    "enable": "Activer la sélection",
    "disable": "Désactiver la sélection"
  },
  "download": "Télécharger",
  "add": "Ajouter",
  "import": "Importer",
  "retryLogin": "Réessayer de s'identifier",
  "retryLogout": "Réessayer de se déconnecter",
  "confirm": "Confirmer",
  "deactivate": "Désactiver",
  "activate": "Activer",
  "upload": "Importer",
  "copied": "Copié",
  "copiedTitle": "Copier dans le presse-papiers",
  "edit": "Modifier"
}
